import styled from 'styled-components';
import { inputBorderColor, screenSize, whiteColor } from '@app/styles';

type Props = {
  selected?: boolean;
};

export const UserFormContainer = styled.div`
  background: ${whiteColor};
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  @media (${screenSize.maxMobile}) {
    width: 100%;
  }
  @media (${screenSize.tablet}) {
    width: calc(100vw - 320px);
  }
`;

export const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 60px);
  width: 100%;
  margin-top: 60px;
  overflow-x: hidden;
  overflow-y: auto;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  @media (${screenSize.maxMobile}) {
    background: ${whiteColor};
  }
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const DesktopSideNav = styled.div`
  display: block;
`;

export const SideNav = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: #ffffff;
  @media (${screenSize.tablet}) {
    width: 320px;
    border-left: none;
    border-right: 1px solid ${inputBorderColor};
  }
`;

export const UserRolesText = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  color: #172b4d;
`;

export const AddUserRole = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
`;

export const UserRolesHeader = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #cecece;
  padding: 10px 16px 10px 16px;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 320px;
  }
`;

export const AddUserRoleButton = styled.div``;

export const UserRole = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #49515f;
  padding: 16px;
  border-bottom: 1px solid #e6e6e6;
  cursor: pointer;
  ${({ selected }: Props) => {
    if (selected) {
      return `background:#EFF1F2`;
    }
  }}
`;

export const UserRoleContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100% - 100px);
  padding-bottom: 32px;
`;
